import { render, staticRenderFns } from "./MediaCallPage.vue?vue&type=template&id=64338dc8&"
import script from "./MediaCallPage.vue?vue&type=script&lang=js&"
export * from "./MediaCallPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports